import React from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  BlogCard,
  Layout,
} from 'components';
import './packages-and-payment-page.less';

import './blog.less';
import blogBannerImg from '../../assests/images/blog-banner-img.png';
import blogBannerAccessory1 from '../../assests/images/pap-accessory-1.png';
import blogBannerAccessory2 from '../../assests/images/features-accessory-3.png';
import { LANDING_MENU } from 'constants/page.const';

const Blog = () => {


  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      <div className="blog-page">
        <div className="blog-banner">
          <div className="container">
            <div>
              <h1 className="section__title--big">
                Company Imperfect, by design
              </h1>
              <p className="info-text--big">
                The journey to responsible, responsive, and community-driven
                machine learning (ML) systems is a collaborative.
              </p>
            </div>
            <figure>
              <img src={blogBannerImg} alt="Blog Banner Image" />
            </figure>
          </div>
          <img
            id="blog-banner-accessory-1"
            src={blogBannerAccessory1}
            alt="Accessory Image"
          />
          <img
            id="blog-banner-accessory-2"
            src={blogBannerAccessory2}
            alt="Accessory Image"
          />
        </div>
        <div className="blogs-wrapper">
          <div className="container">
            <BlogCard />
            <BlogCard />
            <BlogCard />
            <BlogCard />
            <BlogCard />
            <BlogCard />
          </div>
        </div>
      </div>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default Blog;
